var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffPowe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36251 8.20564V2.23608H8.32677V8.20564H7.36251ZM7.84464 12.8806C7.09299 12.8806 6.38585 12.7415 5.72323 12.4634C5.06059 12.1853 4.4812 11.8057 3.98504 11.3247C3.48889 10.8436 3.09741 10.2818 2.8106 9.63928C2.52378 8.99678 2.38037 8.31113 2.38037 7.58231C2.38037 6.79516 2.55098 6.05176 2.8922 5.35212C3.23341 4.65247 3.70895 4.04853 4.31883 3.54027L4.99011 4.19117C4.4717 4.60272 4.06786 5.10458 3.77857 5.69674C3.48928 6.2889 3.34464 6.91743 3.34464 7.58231C3.34464 8.78741 3.78393 9.81591 4.6625 10.6678C5.54107 11.5197 6.60178 11.9456 7.84464 11.9456C9.09821 11.9456 10.1616 11.5197 11.0348 10.6678C11.908 9.81591 12.3446 8.78741 12.3446 7.58231C12.3446 6.91743 12.2027 6.2889 11.9187 5.69674C11.6348 5.10458 11.2283 4.60272 10.6992 4.19117L11.3705 3.54027C11.9845 4.04853 12.461 4.65247 12.8002 5.35212C13.1393 6.05176 13.3089 6.79516 13.3089 7.58231C13.3089 8.31113 13.1655 8.99678 12.8787 9.63928C12.5919 10.2818 12.202 10.8436 11.7092 11.3247C11.2163 11.8057 10.6386 12.1853 9.97595 12.4634C9.31332 12.7415 8.60288 12.8806 7.84464 12.8806Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L14.0549 13.6584",
    stroke: "#FF1212",
    strokeWidth: 0.57538
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffPowe);
export default __webpack_public_path__ + "static/media/offPowe.01bc32c49c403c1ade5919dbf620f710.svg";
export { ForwardRef as ReactComponent };